import { createStyles } from '@mantine/core';

export const useStyles = createStyles(() => ({
  playIcon: {
    '&:hover': {
      scale: '1.1',
    },
  },
}));
